import { CookieScriptBannerLoader, CookieScriptSegmentWrapper } from '@landr/core';
import { SegmentService } from './segment-generated';
import { AnalyticsV2Service } from './AnalyticsV2Service.generated';
export * from './AnalyticsV2Service.generated';

const Analytics = new SegmentService();

export { Analytics as SegmentService };

export const analyticsV2 = new AnalyticsV2Service();

interface LoadBannersAndAnalyticsProps {
    writeKey: string;
    optInBannerId: string;
    optOutBannerId: string;
    enableDebugLogging?: boolean;
}

async function loadBannersAndAnalytics({
    writeKey,
    optInBannerId,
    optOutBannerId,
    enableDebugLogging,
}: LoadBannersAndAnalyticsProps): Promise<void> {
    try {
        const bannerLoader = new CookieScriptBannerLoader({
            optInBannerId,
            optOutBannerId,
        });
        await bannerLoader.loadBanner();
    } catch {
        // If banner loading fails, we can continue without it. Segment wrapper has a fallback to manage analytics to the strictest privacy settings.
    }

    const withCookieScriptWrapper = CookieScriptSegmentWrapper.createCookieScriptWrapper({
        optInBannerId,
        optOutBannerId,
        enableDebugLogging,
    });

    await analyticsV2.load(writeKey, {
        consentWrapper: withCookieScriptWrapper,
    });
}

loadBannersAndAnalytics({
    writeKey: process.env.GATSBY_SEGMENT_WRITE_KEY as string,
    optInBannerId: process.env.GATSBY_OPT_IN_BANNER_ID as string,
    optOutBannerId: process.env.GATSBY_OPT_OUT_BANNER_ID as string,
    enableDebugLogging: process.env.GATSBY_ENV !== 'production',
});
